import React, { FC } from 'react';
import { FSMonthPickerProps } from './interface';
import { DatePicker, Tooltip } from '@firesoon/antd';
import moment from 'moment';
import './index.less';

const { MonthPicker } = DatePicker;

const Index: FC<FSMonthPickerProps> = ({
  disableFuture = true,
  notDefaultRender = true,
  monthCellFooterRender,
  tipRender,
  style = {},
  ...rest
}) => {
  const defaultConfig = {
    disabledDate(current) {
      return disableFuture ? current && current > moment() : false;
    },
    allowClear: false,
    monthCellContentRender: notDefaultRender
      ? (current, locale) => MonthRender(monthCellFooterRender, tipRender, current, locale)
      : undefined,
    style: {
      width: 120,
      ...style,
    },
  };
  // ! 不管上层使用什么，都按此组件的来
  const importantConfig = {
    dropdownClassName: `fs-calendar-picker-container${notDefaultRender ? ' fs-monthpicker-not-default-render' : ''}`,
  };

  return <MonthPicker {...defaultConfig} {...rest} {...importantConfig} />;
};

// eslint-disable-next-line max-params
export const MonthRender = (monthCellFooterRender, tipRender, date, locale) => (
  <div
    className={`fs-calendar-month-panel-month auto-track${monthCellFooterRender ? ' fs-monthpicker-not-default-render-sub' : ''
      }`}
    // 自定义页脚存在提示信息时，屏蔽默认提示信息，否则存在多个提示信息会遮挡
    title={tipRender ? '' : date.format('YYYY年MMM')}
    data-log-value={date.format('YYYY年MMM')}
  >
    <Tooltip
      getPopupContainer={() => document.body}
      placement="bottom"
      title={tipRender ? tipRender(date, locale) : undefined}
    >
      <div className="fs-calendar-month-panel-month-content">{date.format('MMMM')}</div>
    </Tooltip>

    <div className="fs-calendar-month-panel-month-footer" style={{ minHeight: tipRender ? 24 : 0 }}>
      {monthCellFooterRender?.(date, locale)}
    </div>
  </div>
);

export default Index;
